export enum HybridPolicyRule {
  REMOTE = "remote",
  OFFICE = "office",
  NONE = "none",
}
